<template>
  <div>
    <v-container>
      <form class="mt-5">
        <div class="text-center">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Nombre
                </label>
                <input v-model="user_edit.name" name="name" v-validate="'required'" data-vv-as="Nombre" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('name')" class="text-danger mt-2">
                  {{ errors.first("name") }}
                </span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Apellido
                </label>
                <input v-model="user_edit.lastname" name="lastname" v-validate="'required'" data-vv-as="Apellido" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('lastname')" class="text-danger mt-2">
                  {{ errors.first("lastname") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Telefono
                </label>
                <input v-model="user_edit.phone" class="input-nv" id="name">
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Correo electrónico
                </label>
                <input readonly v-model="user_edit.email" name="email" v-validate="'required|email'" data-vv-as="Correo electrónico" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('email')" class="text-danger mt-2">
                  {{ errors.first("email") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Nueva contraseña
                </label>
                <input v-model="user_edit.password" class="input-nv" id="name">
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  <span v-if="user_edit.password">*</span> Confirmar contraseña
                </label>
                <input v-model="user_edit.confirm_pw" name="confirm_pw" v-validate="user_edit.password ? 'required' : ''" data-vv-as="Confirmar contraseña" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('confirm_pw')" class="text-danger mt-2">
                  {{ errors.first("confirm_pw") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col text-center">
              <p class="color-blue font-general-r h4">
                Los campos marcados con (*) son obligatorios
              </p>
              <div class="text-center">
                <v-btn :loading="loading_edit_user" @click="updateProfile()" elevation="0" color="primary" class="nv-btn mt-5">
                  ACTUALIZAR
                </v-btn> <br>
                <v-btn @click="() => $emit('closeModal')" text elevation="0" color="accent" class="mt-5 font-weight-bold">CANCELAR</v-btn>
              </div>
            </div>
          </div>

        </div>
      </form>
    </v-container>

    <PopupMessage
      ref="popupMessage"
      message="Tus datos han sido editados correctamente"
    />

  </div>
</template>

<script>
import UserService from '@/services/user.service'

export default {
  props: ['user_edit'],
  data() {
    return {
      snackbar: false,
      loading_edit_user: false
    }
  },
  methods: {
    async updateProfile() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.loading_edit_user = true
          const { data:res } = await UserService.updateProfile(this.user_edit)
          if (res.success) {
            this.$store.dispatch('setUser', res.data)
            this.$emit('closeModal')
            setTimeout(() => {
              this.$refs.popupMessage.openDialog()
            }, 500)
          } else {
            this.$swal(res.error, '', 'warning')
          }
          this.loading_edit_user = false
        }
      })
    }
  }
}
</script>
